import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { SharePointStructureCreatorComponent } from "./sharepoint-structure-creator.component";
import { BoardComponent } from "./components/board/board.component";
import { ScriptEditorComponent } from "./components/script-editor/script-editor.component";
import { FolderSettingsComponent } from "./components/folder-settings/folder-settings.component";
import { LibrarySettingsComponent } from "./components/library-settings/library-settings.component";
import { SiteSettingsComponent } from "./components/site-settings/site-settings.component";
import { SiteCollectionSettingsComponent } from "./components/site-collection-settings/site-collection-settings.component";
import { GeneralSettingsComponent } from "./components/general-settings/general-settings.component";

const routes: Routes = [
  {
    path: "",
    component: SharePointStructureCreatorComponent,    
    children: [
      {
        path: "",
        redirectTo: "board",
        pathMatch: "full"
      },
      {
        path: "board",
        component: BoardComponent        
      },
      {
        path: "general",
        component: GeneralSettingsComponent
      },
      {
        path: "folder",
        component: FolderSettingsComponent
      },
      {
        path: "library",
        component: LibrarySettingsComponent
      },
      {
        path: "site",
        component: SiteSettingsComponent
      },
      {
        path: "site-collection",
        component: SiteCollectionSettingsComponent
      },
      {
        path: "script-editor",
        component: ScriptEditorComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharePointStructureCreatorRoutingModule {}
